import { AppRoutes } from "./routes";
import { BrowserRouter } from "react-router-dom";
import { SWRConfig } from "swr";
import { swrFetcher } from "./api/http";
import { GlobalLoadingIndicator } from "./components/GlobalLoadingIndicator";
import { AuthProvider } from "./auth";
import { UserProvider } from "./auth/UserProvider";
import { Toaster } from "react-hot-toast";
import { FirebaseProvider } from "./firebase/firebase";
import { useEffect } from "react";
import bgImg from "./assets/OccupancyBG.png";
import bgGif from "./assets/OccupancyBG.gif";

function App() {
  // Preload heavy images on app startup
  useEffect(() => {
    const img1 = new Image();
    const img2 = new Image();
    img1.src = bgImg;
    img2.src = bgGif;
  }, []);

  return (
    <SWRConfig value={{ fetcher: swrFetcher }}>
      <FirebaseProvider>
        <BrowserRouter>
          <GlobalLoadingIndicator>
            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  zIndex: 99999,
                },
              }}
            />
            <AuthProvider>
              <UserProvider>
                <AppRoutes />
              </UserProvider>
            </AuthProvider>
          </GlobalLoadingIndicator>
        </BrowserRouter>
      </FirebaseProvider>
    </SWRConfig>
  );
}

export default App;
